const verifyProfile = (user, roles) => {
    return roles.indexOf(user.perfil_nome) > -1;
}

export default verifyProfile;